import Image from "../images/strengths-image.png"; 
import Logo from "../images/logo.png"; 

const Strengths = () => {
  return (
    <section id="strengths" className="bg-white w-full relative">
      <div className="flex flex-col lg:flex-row bg-sky-950 shadow-lg overflow-hidden py-8 min-h-[500px] relative">
        
        {/* Background Logo - Adjusted for Responsiveness */}
        <img
          src={Logo}
          alt="Company Logo"
          className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 opacity-10 
                     w-[200px] sm:w-[350px] md:w-[500px] lg:w-[700px] xl:w-[900px] object-contain"
        />

        {/* Left: Text Content */}
        <div className="w-full lg:w-3/4 p-6 md:p-12 lg:p-16 flex flex-col justify-center relative z-10">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 md:mb-6 text-white">
            Key Strengths
          </h2>

          <div className="space-y-6 md:space-y-8 text-gray-300 text-base md:text-lg lg:text-xl text-justify">
            <div>
              <h6 className="text-lg md:text-xl lg:text-2xl font-bold text-white mb-2">Market Expertise:</h6>
              <p>Years of experience in grain markets.</p>
            </div>

            <div>
              <h3 className="text-lg md:text-xl lg:text-2xl font-bold text-white mb-2">Efficient Supply Chain:</h3>
              <p>Advanced logistics and technology-driven operations ensure prompt delivery.</p>
            </div>

            <div>
              <h3 className="text-lg md:text-xl lg:text-2xl font-bold text-white mb-2">Commitment to Quality:</h3>
              <p>Rigorous quality control measures at every stage of the supply chain.</p>
            </div>

            <div>
              <h3 className="text-lg md:text-xl lg:text-2xl font-bold text-white mb-2">Sustainability Focus:</h3>
              <p>Programs that empower farmers and promote environmentally friendly practices.</p>
            </div>
          </div>
        </div>

        {/* Right: Image */}
        <div className="w-full lg:w-1/4 flex justify-center lg:justify-end relative z-10">
          <img
            src={Image}
            alt="Strengths Image"
            className="w-full max-w-[300px] md:max-w-[400px] lg:max-w-[450px] h-auto object-contain rounded-lg"
          />
        </div>

      </div>
    </section>
  );
};

export default Strengths;
